import { render, staticRenderFns } from "./ivmrecv.vue?vue&type=template&id=458ac28a&"
import script from "./ivmrecv.vue?vue&type=script&lang=js&"
export * from "./ivmrecv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports